// extracted by mini-css-extract-plugin
export default {"root":"table_root__HB3Ne","wide":"table_wide__iBGmG","borderTop":"table_borderTop__2mABM","placeHolderShimmer":"table_placeHolderShimmer__WkWkl"};